import React from 'react';
import {
  Box,
  Container,
  Card,
  CardContent,
  Typography,
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ShareIcon from '@mui/icons-material/Share';

import MUITypography from '../../Components/MUITypography';
import SocialMediaIcons from '../../Components/SocialMediaIcons';
import { VM_Colors } from '../../Styles/VMStyles';
import LandingToolBar from '../../Main/Landing/LangingToolBar';
import { isEmpty } from '../../Util/UtilHelper';
import StorageFactory from '../../Util/StorageFactory';
import { SESSION_USER_ID_KEY } from '../../Util/VMConstants';

const iconBoxSx = {
  width: 48,
  height: 48,
  borderRadius: 2.5,
  backgroundColor: VM_Colors.primary, // slate-800
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#fff',
  flexShrink: 0,
};

const cardSx = {
  borderRadius: 3,
  backgroundColor: '#ffffff',
  boxShadow: '0 8px 24px rgba(15, 23, 42, 0.06)',
  transition: 'all 0.25s ease',
  '&:hover': {
    boxShadow: '0 12px 32px rgba(15, 23, 42, 0.12)',
    transform: 'translateY(-2px)',
  },
};

const ContactUs = () => {

  const sessionFactory = new StorageFactory("session");
  const userID = sessionFactory.get(SESSION_USER_ID_KEY);

  return (
    <Box sx={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
       {
       <Box sx={{mb:4}}>
        {
          isEmpty(userID) &&    <LandingToolBar/>  
        }
       </Box>
      }
      <Container maxWidth="md" 
      // sx={{ py: { xs: 6, md: 10 } }}
      >
       

        {/* Badge */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          {/* <MUITypography variant='h3' label='Get in Touch' sx={{fontWeight:700}}/> */}
          <Box
            sx={{
              px: 3,
              py: 0.6,
              borderRadius: 999,
              backgroundColor: '#e2e8f0',
              fontSize: 13,
              fontWeight: 600,
              letterSpacing: 0.3,
              color: '#1e293b',
            }}
          >
           <MUITypography variant='h3' label='Get in Touch' sx={{fontWeight:700}}/> 
          </Box>
        </Box>

        {/* Heading */}
        {/* <Typography
          align="center"
          sx={{
            fontSize: { xs: 32, md: 48 },
            fontWeight: 600,
            fontFamily: 'Inter, system-ui, sans-serif',
            color: '#0f172a',
            mb: 2,
          }}
        >
          Contact Us
        </Typography> */}

        {/* Subtitle */}
        <Typography
          align="center"
          sx={{
            color: '#64748b',
            fontSize: { xs: 15, md: 17 },
            lineHeight: 1.7,
            maxWidth: 560,
            mx: 'auto',
          }}
        >
          Send us your query anytime. Our team is always happy to help you with
          any questions or concerns.
        </Typography>

        {/* Illustration */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 10 }}>
          <Box
            component="img"
            src={'/static/contact-us-bro.svg'}
            alt="Contact Illustration"
            sx={{
              width: '100%',
              maxWidth: 360,
              height:'200px',
              objectFit: 'contain',
            }}
          />
        </Box>

        {/* Cards Wrapper */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {/* Address */}
          <Card sx={cardSx}>
            <CardContent sx={{ display: 'flex', gap: 3, p: { xs: 3, md: 4 } }}>
              <Box sx={iconBoxSx}>
                <LocationOnIcon fontSize="small"  />
              </Box>
              <Box>
                <Typography sx={{ fontWeight: 600, mb: 1, color: '#0f172a' }}>
                  Our Office
                </Typography>
                <Typography sx={{ fontWeight: 600, mb: 0.75, color: '#0f172a' }}>
                  GAAMI WORKS CONSULTING PRIVATE LIMITED
                </Typography>
                <Typography sx={{ color: '#64748b', lineHeight: 1.7 }}>
                  402, 7-1-50, Siddharatha Apartments,
                  <br />
                  Dharam Karam Road,
                  <br />
                  Hyderabad, Telangana 500038,
                  <br />
                  India
                </Typography>
              </Box>
            </CardContent>
          </Card>

          {/* Email + Phone */}
          <Box
            sx={{
              display: 'flex',
              gap: 4,
              flexDirection: { xs: 'column', md: 'row' },
            }}
          >
            {/* Email */}
            <Box sx={{ flex: 1 }}>
              <Card sx={cardSx}>
                <CardContent sx={{ display: 'flex', gap: 3, p: { xs: 3, md: 4 } }}>
                  <Box sx={iconBoxSx}>
                    <EmailIcon fontSize="small" />
                  </Box>
                  <Box>
                    <Typography sx={{ fontWeight: 600, mb: 1 }}>
                      Email Us
                    </Typography>
                    <Typography
                      component="a"
                      href="mailto:info@venuemanagercrm.com"
                      sx={{
                        color: '#475569',
                        textDecoration: 'none',
                        fontWeight: 500,
                        '&:hover': { color: '#0f172a' },
                      }}
                    >
                      info@venuemanagercrm.com
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Box>

            {/* Phone */}
            <Box sx={{ flex: 1 }}>
              <Card sx={cardSx}>
                <CardContent sx={{ display: 'flex', gap: 3, p: { xs: 3, md: 4 } }}>
                  <Box sx={iconBoxSx}>
                    <PhoneIcon fontSize="small" />
                  </Box>
                  <Box>
                    <Typography sx={{ fontWeight: 600, mb: 1 }}>
                      Call Us
                    </Typography>
                    <Typography
                      component="a"
                      href="tel:+918897545660"
                      sx={{
                        color: '#475569',
                        textDecoration: 'none',
                        fontWeight: 500,
                        '&:hover': { color: '#0f172a' },
                      }}
                    >
                      +91 88975 45660
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          </Box>

          {/* Working Hours */}
          <Card sx={cardSx}>
            <CardContent sx={{ display: 'flex', gap: 3, p: { xs: 3, md: 4 } }}>
              <Box sx={iconBoxSx}>
                <AccessTimeIcon fontSize="small" />
              </Box>
              <Box>
                <Typography sx={{ fontWeight: 600, mb: 1 }}>
                  Working Hours
                </Typography>
                <Typography sx={{ color: '#64748b' }}>
                  <strong style={{ color: '#0f172a' }}>
                    Monday – Friday
                  </strong>
                  <span style={{ margin: '0 6px', color: '#f59e0b' }}>•</span>
                  9:00 AM to 6:00 PM
                </Typography>
              </Box>
            </CardContent>
          </Card>

          <Card sx={cardSx}>
            <CardContent sx={{ display: 'flex', gap: 3, p: { xs: 3, md: 4 } }}>
              <Box sx={iconBoxSx}>
                <ShareIcon fontSize="small" />
              </Box>
              <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontWeight: 600, mb: 1 }}>
                  Follow Us
                </Typography>
                <SocialMediaIcons brandColors />
              </Box>
            </CardContent>
          </Card>
        </Box>

        {/* Footer Note */}
        <Typography
          align="center"
          sx={{
            mt: 8,
            fontSize: 14,
            color: '#64748b',
          }}
        >
          We typically respond within 24 hours during business days.
        </Typography>
      </Container>
    </Box>
  );
};

export default ContactUs;
